module.exports = __webpack_public_path__ + "70a7f198d2d93819864f6e46ae06a9fa.svg";